import { TealiumCollectSdk } from './TealiumCollectSdk';
import { TealiumSdk } from './TealiumSdk';

export const createTealiumSdk = (): TealiumSdk => new TealiumCollectSdk();
